import { BsMusicNoteBeamed } from 'react-icons/bs';

import { useAudioPlayerContext } from '../context/audio-player-context';
import YAudioImage from '../../YAudioImage';
import { JSXMap } from 'fennec-ui';
import React from 'react';

export const TrackInfo = () => {
  const { currentTrack, setCurrentTrack, isPlaying, setIsPlaying } = useAudioPlayerContext();
  const play = () => {
    if(!isPlaying){ 
        // setCurrentTrack(currentTrack);
        setIsPlaying(true);
    } else { 
        setIsPlaying(false);
    }
};
  return (
    <div
      // className="flex items-center gap-4"
      style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <div
        // className="w-24 h-24 flex items-center justify-center bg-gray-200 rounded-md overflow-hidden"
        style={{ width: "96px", height: "96px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "transparent", borderRadius: "6px", overflow: "hidden" }}>

          <div onClick={play}>
          <YAudioImage
            playing={isPlaying}
            error={false}
            width={96}
            image={currentTrack?.picture}
            minimage={currentTrack?.picture}
            hidePreview={true}
            imageStyle={{ borderRadius: "4px", border: "1px solid transparent", borderRadius: "4px", width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
      </div>
      <div>
        <div style={{ fontWeight: "bold", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "256px", color: "white" }}>
          {currentTrack?.nazvanieTreka}
        </div>
        <div style={{ fontSize: "14px", lineHeight: "1.4286", color: "#99a1af", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "256px" }}>
          {currentTrack?.sozdateliTrekaTrek && <React.Fragment>
            {JSXMap(currentTrack?.sozdateliTrekaTrek, (sitem, idx) => {
              return (<span key={idx}>{(idx > 0) ? ", " : ""}{sitem?.sozdatel?.familiya} {sitem?.sozdatel?.imya}{(sitem?.sozdatel?.psevdonim) ? " (" + sitem?.sozdatel?.psevdonim + ")" : ""}</span>)
            })}
          </React.Fragment>}
        </div>
        {/* <p
          // className="font-bold lg:truncate lg:max-w-64"
          style={{ fontWeight: "bold", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "256px", color: "white" }}>
          {currentTrack?.title}
        </p>
        <p
          // className="text-sm text-gray-400"
          style={{ fontSize: "14px", lineHeight: "1.4286", color: "#99a1af" }}>{currentTrack?.author}</p> */}
      </div>
    </div>
  );
};
